import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-to-do-list.svg';

import { ActivitiesReminder } from '../components/ActivitiesReminder';

interface Props {
    goToPreviousStep: () => void;
}

export const WeekThreePlanStep: React.SFC<Props> = ({ goToPreviousStep }) => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading small>Homework:</S.StepHeading>
            <S.StepHeading>Follow through on your plan</S.StepHeading>
            <S.StepDescription small>
                This week, follow through on the 1-3 activities you planned!
            </S.StepDescription>
            <S.StepDescription small>
                Bonus: Notice if you can be mindful as you practice these activities.
            </S.StepDescription>
            <S.PlannedActivitiesHolder>
                <S.PlannedActivitiesHeading>Planned activities:</S.PlannedActivitiesHeading>
                <ActivitiesReminder />
            </S.PlannedActivitiesHolder>
            <S.StepDescription small>
                Back to previous screen to{' '}
                <S.TextLink onClick={goToPreviousStep}>Change my activities.</S.TextLink>
            </S.StepDescription>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon iconUrl={stepIcon} />
        </S.ContentColumn>
    </S.ContentRow>
);
